// automatically generated by the FlatBuffers compiler, do not modify

/**
 * @const
 * @namespace
 */
var chat = chat || {};

/**
 * @const
 * @namespace
 */
chat.Schema = chat.Schema || {};

/**
 * @enum {number}
 */
chat.Schema.Data = {
  NONE: 0,
  Chat: 1,
  Credentials: 2,
  Auth: 3,
  Room: 4,
  ListRoom: 5,
  HistoryRequest: 6,
  HistoryChat: 7,
  UserStatus: 8,
  IncommingMessage: 9,
  ReadMessage: 10,
  AppStatus: 11,
  AppNotification: 12
};

/**
 * @enum {string}
 */
chat.Schema.DataName = {
  '0': 'NONE',
  '1': 'Chat',
  '2': 'Credentials',
  '3': 'Auth',
  '4': 'Room',
  '5': 'ListRoom',
  '6': 'HistoryRequest',
  '7': 'HistoryChat',
  '8': 'UserStatus',
  '9': 'IncommingMessage',
  '10': 'ReadMessage',
  '11': 'AppStatus',
  '12': 'AppNotification'
};

/**
 * @enum {number}
 */
chat.Schema.Command = {
  SERVER_INFO: 0,
  HISTORY_CHAT: 1,
  CHAT_MESSAGE: 2,
  SENT_MESSAGE: 3,
  READ_MESSAGE: 4,
  INCOMMING_MESSAGE: 5,
  LOGIN: 6,
  LIST_ROOM: 7,
  USER_STATUS: 8,
  APP_STATUS: 9,
  APP_NOTIFICATION: 10
};

/**
 * @enum {string}
 */
chat.Schema.CommandName = {
  '0': 'SERVER_INFO',
  '1': 'HISTORY_CHAT',
  '2': 'CHAT_MESSAGE',
  '3': 'SENT_MESSAGE',
  '4': 'READ_MESSAGE',
  '5': 'INCOMMING_MESSAGE',
  '6': 'LOGIN',
  '7': 'LIST_ROOM',
  '8': 'USER_STATUS',
  '9': 'APP_STATUS',
  '10': 'APP_NOTIFICATION'
};

/**
 * @enum {number}
 */
chat.Schema.StatusCode = {
  SUCCESS: 0,
  ERROR: 1,
  NODATA: 2,
  SESSION_TIMEOUT: 3
};

/**
 * @enum {string}
 */
chat.Schema.StatusCodeName = {
  '0': 'SUCCESS',
  '1': 'ERROR',
  '2': 'NODATA',
  '3': 'SESSION_TIMEOUT'
};

/**
 * @constructor
 */
chat.Schema.Message = function() {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  this.bb = null;

  /**
   * @type {number}
   */
  this.bb_pos = 0;
};

/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {chat.Schema.Message}
 */
chat.Schema.Message.prototype.__init = function(i, bb) {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.Message=} obj
 * @returns {chat.Schema.Message}
 */
chat.Schema.Message.getRootAsMessage = function(bb, obj) {
  return (obj || new chat.Schema.Message).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.Message=} obj
 * @returns {chat.Schema.Message}
 */
chat.Schema.Message.getSizePrefixedRootAsMessage = function(bb, obj) {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new chat.Schema.Message).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns {chat.Schema.Command}
 */
chat.Schema.Message.prototype.cmd = function() {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? /** @type {chat.Schema.Command} */ (this.bb.readInt8(this.bb_pos + offset)) : chat.Schema.Command.SERVER_INFO;
};

/**
 * @returns {chat.Schema.StatusCode}
 */
chat.Schema.Message.prototype.statusCode = function() {
  var offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? /** @type {chat.Schema.StatusCode} */ (this.bb.readInt8(this.bb_pos + offset)) : chat.Schema.StatusCode.SUCCESS;
};

/**
 * @returns {chat.Schema.Data}
 */
chat.Schema.Message.prototype.dataType = function() {
  var offset = this.bb.__offset(this.bb_pos, 8);
  return offset ? /** @type {chat.Schema.Data} */ (this.bb.readUint8(this.bb_pos + offset)) : chat.Schema.Data.NONE;
};

/**
 * @param {flatbuffers.Table} obj
 * @returns {?flatbuffers.Table}
 */
chat.Schema.Message.prototype.data = function(obj) {
  var offset = this.bb.__offset(this.bb_pos, 10);
  return offset ? this.bb.__union(obj, this.bb_pos + offset) : null;
};

/**
 * @param {flatbuffers.Builder} builder
 */
chat.Schema.Message.startMessage = function(builder) {
  builder.startObject(4);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {chat.Schema.Command} cmd
 */
chat.Schema.Message.addCmd = function(builder, cmd) {
  builder.addFieldInt8(0, cmd, chat.Schema.Command.SERVER_INFO);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {chat.Schema.StatusCode} statusCode
 */
chat.Schema.Message.addStatusCode = function(builder, statusCode) {
  builder.addFieldInt8(1, statusCode, chat.Schema.StatusCode.SUCCESS);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {chat.Schema.Data} dataType
 */
chat.Schema.Message.addDataType = function(builder, dataType) {
  builder.addFieldInt8(2, dataType, chat.Schema.Data.NONE);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} dataOffset
 */
chat.Schema.Message.addData = function(builder, dataOffset) {
  builder.addFieldOffset(3, dataOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
chat.Schema.Message.endMessage = function(builder) {
  var offset = builder.endObject();
  return offset;
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} offset
 */
chat.Schema.Message.finishMessageBuffer = function(builder, offset) {
  builder.finish(offset);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} offset
 */
chat.Schema.Message.finishSizePrefixedMessageBuffer = function(builder, offset) {
  builder.finish(offset, undefined, true);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {chat.Schema.Command} cmd
 * @param {chat.Schema.StatusCode} statusCode
 * @param {chat.Schema.Data} dataType
 * @param {flatbuffers.Offset} dataOffset
 * @returns {flatbuffers.Offset}
 */
chat.Schema.Message.createMessage = function(builder, cmd, statusCode, dataType, dataOffset) {
  chat.Schema.Message.startMessage(builder);
  chat.Schema.Message.addCmd(builder, cmd);
  chat.Schema.Message.addStatusCode(builder, statusCode);
  chat.Schema.Message.addDataType(builder, dataType);
  chat.Schema.Message.addData(builder, dataOffset);
  return chat.Schema.Message.endMessage(builder);
}

/**
 * @constructor
 */
chat.Schema.IncommingMessage = function() {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  this.bb = null;

  /**
   * @type {number}
   */
  this.bb_pos = 0;
};

/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {chat.Schema.IncommingMessage}
 */
chat.Schema.IncommingMessage.prototype.__init = function(i, bb) {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.IncommingMessage=} obj
 * @returns {chat.Schema.IncommingMessage}
 */
chat.Schema.IncommingMessage.getRootAsIncommingMessage = function(bb, obj) {
  return (obj || new chat.Schema.IncommingMessage).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.IncommingMessage=} obj
 * @returns {chat.Schema.IncommingMessage}
 */
chat.Schema.IncommingMessage.getSizePrefixedRootAsIncommingMessage = function(bb, obj) {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new chat.Schema.IncommingMessage).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns {number}
 */
chat.Schema.IncommingMessage.prototype.roomId = function() {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
};

/**
 * @returns {number}
 */
chat.Schema.IncommingMessage.prototype.userId = function() {
  var offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
chat.Schema.IncommingMessage.prototype.userName = function(optionalEncoding) {
  var offset = this.bb.__offset(this.bb_pos, 8);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @returns {number}
 */
chat.Schema.IncommingMessage.prototype.status = function() {
  var offset = this.bb.__offset(this.bb_pos, 10);
  return offset ? this.bb.readInt8(this.bb_pos + offset) : 0;
};

/**
 * @param {flatbuffers.Builder} builder
 */
chat.Schema.IncommingMessage.startIncommingMessage = function(builder) {
  builder.startObject(4);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} roomId
 */
chat.Schema.IncommingMessage.addRoomId = function(builder, roomId) {
  builder.addFieldInt32(0, roomId, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} userId
 */
chat.Schema.IncommingMessage.addUserId = function(builder, userId) {
  builder.addFieldInt32(1, userId, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} userNameOffset
 */
chat.Schema.IncommingMessage.addUserName = function(builder, userNameOffset) {
  builder.addFieldOffset(2, userNameOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} status
 */
chat.Schema.IncommingMessage.addStatus = function(builder, status) {
  builder.addFieldInt8(3, status, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
chat.Schema.IncommingMessage.endIncommingMessage = function(builder) {
  var offset = builder.endObject();
  return offset;
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} roomId
 * @param {number} userId
 * @param {flatbuffers.Offset} userNameOffset
 * @param {number} status
 * @returns {flatbuffers.Offset}
 */
chat.Schema.IncommingMessage.createIncommingMessage = function(builder, roomId, userId, userNameOffset, status) {
  chat.Schema.IncommingMessage.startIncommingMessage(builder);
  chat.Schema.IncommingMessage.addRoomId(builder, roomId);
  chat.Schema.IncommingMessage.addUserId(builder, userId);
  chat.Schema.IncommingMessage.addUserName(builder, userNameOffset);
  chat.Schema.IncommingMessage.addStatus(builder, status);
  return chat.Schema.IncommingMessage.endIncommingMessage(builder);
}

/**
 * @constructor
 */
chat.Schema.ReadMessage = function() {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  this.bb = null;

  /**
   * @type {number}
   */
  this.bb_pos = 0;
};

/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {chat.Schema.ReadMessage}
 */
chat.Schema.ReadMessage.prototype.__init = function(i, bb) {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.ReadMessage=} obj
 * @returns {chat.Schema.ReadMessage}
 */
chat.Schema.ReadMessage.getRootAsReadMessage = function(bb, obj) {
  return (obj || new chat.Schema.ReadMessage).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.ReadMessage=} obj
 * @returns {chat.Schema.ReadMessage}
 */
chat.Schema.ReadMessage.getSizePrefixedRootAsReadMessage = function(bb, obj) {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new chat.Schema.ReadMessage).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns {number}
 */
chat.Schema.ReadMessage.prototype.roomId = function() {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
};

/**
 * @returns {number}
 */
chat.Schema.ReadMessage.prototype.userId = function() {
  var offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
chat.Schema.ReadMessage.prototype.lastReadTime = function(optionalEncoding) {
  var offset = this.bb.__offset(this.bb_pos, 8);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param {flatbuffers.Builder} builder
 */
chat.Schema.ReadMessage.startReadMessage = function(builder) {
  builder.startObject(3);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} roomId
 */
chat.Schema.ReadMessage.addRoomId = function(builder, roomId) {
  builder.addFieldInt32(0, roomId, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} userId
 */
chat.Schema.ReadMessage.addUserId = function(builder, userId) {
  builder.addFieldInt32(1, userId, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} lastReadTimeOffset
 */
chat.Schema.ReadMessage.addLastReadTime = function(builder, lastReadTimeOffset) {
  builder.addFieldOffset(2, lastReadTimeOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
chat.Schema.ReadMessage.endReadMessage = function(builder) {
  var offset = builder.endObject();
  return offset;
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} roomId
 * @param {number} userId
 * @param {flatbuffers.Offset} lastReadTimeOffset
 * @returns {flatbuffers.Offset}
 */
chat.Schema.ReadMessage.createReadMessage = function(builder, roomId, userId, lastReadTimeOffset) {
  chat.Schema.ReadMessage.startReadMessage(builder);
  chat.Schema.ReadMessage.addRoomId(builder, roomId);
  chat.Schema.ReadMessage.addUserId(builder, userId);
  chat.Schema.ReadMessage.addLastReadTime(builder, lastReadTimeOffset);
  return chat.Schema.ReadMessage.endReadMessage(builder);
}

/**
 * @constructor
 */
chat.Schema.Chat = function() {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  this.bb = null;

  /**
   * @type {number}
   */
  this.bb_pos = 0;
};

/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {chat.Schema.Chat}
 */
chat.Schema.Chat.prototype.__init = function(i, bb) {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.Chat=} obj
 * @returns {chat.Schema.Chat}
 */
chat.Schema.Chat.getRootAsChat = function(bb, obj) {
  return (obj || new chat.Schema.Chat).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.Chat=} obj
 * @returns {chat.Schema.Chat}
 */
chat.Schema.Chat.getSizePrefixedRootAsChat = function(bb, obj) {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new chat.Schema.Chat).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
chat.Schema.Chat.prototype.id = function(optionalEncoding) {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
chat.Schema.Chat.prototype.content = function(optionalEncoding) {
  var offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @returns {number}
 */
chat.Schema.Chat.prototype.author = function() {
  var offset = this.bb.__offset(this.bb_pos, 8);
  return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
};

/**
 * @returns {number}
 */
chat.Schema.Chat.prototype.roomId = function() {
  var offset = this.bb.__offset(this.bb_pos, 10);
  return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
chat.Schema.Chat.prototype.time = function(optionalEncoding) {
  var offset = this.bb.__offset(this.bb_pos, 12);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param {flatbuffers.Builder} builder
 */
chat.Schema.Chat.startChat = function(builder) {
  builder.startObject(5);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} idOffset
 */
chat.Schema.Chat.addId = function(builder, idOffset) {
  builder.addFieldOffset(0, idOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} contentOffset
 */
chat.Schema.Chat.addContent = function(builder, contentOffset) {
  builder.addFieldOffset(1, contentOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} author
 */
chat.Schema.Chat.addAuthor = function(builder, author) {
  builder.addFieldInt32(2, author, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} roomId
 */
chat.Schema.Chat.addRoomId = function(builder, roomId) {
  builder.addFieldInt32(3, roomId, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} timeOffset
 */
chat.Schema.Chat.addTime = function(builder, timeOffset) {
  builder.addFieldOffset(4, timeOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
chat.Schema.Chat.endChat = function(builder) {
  var offset = builder.endObject();
  builder.requiredField(offset, 6); // content
  return offset;
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} idOffset
 * @param {flatbuffers.Offset} contentOffset
 * @param {number} author
 * @param {number} roomId
 * @param {flatbuffers.Offset} timeOffset
 * @returns {flatbuffers.Offset}
 */
chat.Schema.Chat.createChat = function(builder, idOffset, contentOffset, author, roomId, timeOffset) {
  chat.Schema.Chat.startChat(builder);
  chat.Schema.Chat.addId(builder, idOffset);
  chat.Schema.Chat.addContent(builder, contentOffset);
  chat.Schema.Chat.addAuthor(builder, author);
  chat.Schema.Chat.addRoomId(builder, roomId);
  chat.Schema.Chat.addTime(builder, timeOffset);
  return chat.Schema.Chat.endChat(builder);
}

/**
 * @constructor
 */
chat.Schema.HistoryChat = function() {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  this.bb = null;

  /**
   * @type {number}
   */
  this.bb_pos = 0;
};

/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {chat.Schema.HistoryChat}
 */
chat.Schema.HistoryChat.prototype.__init = function(i, bb) {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.HistoryChat=} obj
 * @returns {chat.Schema.HistoryChat}
 */
chat.Schema.HistoryChat.getRootAsHistoryChat = function(bb, obj) {
  return (obj || new chat.Schema.HistoryChat).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.HistoryChat=} obj
 * @returns {chat.Schema.HistoryChat}
 */
chat.Schema.HistoryChat.getSizePrefixedRootAsHistoryChat = function(bb, obj) {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new chat.Schema.HistoryChat).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns {number}
 */
chat.Schema.HistoryChat.prototype.roomId = function() {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
};

/**
 * @param {number} index
 * @param {chat.Schema.Chat=} obj
 * @returns {chat.Schema.Chat}
 */
chat.Schema.HistoryChat.prototype.messages = function(index, obj) {
  var offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? (obj || new chat.Schema.Chat).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
};

/**
 * @returns {number}
 */
chat.Schema.HistoryChat.prototype.messagesLength = function() {
  var offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @param {flatbuffers.Builder} builder
 */
chat.Schema.HistoryChat.startHistoryChat = function(builder) {
  builder.startObject(2);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} roomId
 */
chat.Schema.HistoryChat.addRoomId = function(builder, roomId) {
  builder.addFieldInt32(0, roomId, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} messagesOffset
 */
chat.Schema.HistoryChat.addMessages = function(builder, messagesOffset) {
  builder.addFieldOffset(1, messagesOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<flatbuffers.Offset>} data
 * @returns {flatbuffers.Offset}
 */
chat.Schema.HistoryChat.createMessagesVector = function(builder, data) {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
chat.Schema.HistoryChat.startMessagesVector = function(builder, numElems) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
chat.Schema.HistoryChat.endHistoryChat = function(builder) {
  var offset = builder.endObject();
  return offset;
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} roomId
 * @param {flatbuffers.Offset} messagesOffset
 * @returns {flatbuffers.Offset}
 */
chat.Schema.HistoryChat.createHistoryChat = function(builder, roomId, messagesOffset) {
  chat.Schema.HistoryChat.startHistoryChat(builder);
  chat.Schema.HistoryChat.addRoomId(builder, roomId);
  chat.Schema.HistoryChat.addMessages(builder, messagesOffset);
  return chat.Schema.HistoryChat.endHistoryChat(builder);
}

/**
 * @constructor
 */
chat.Schema.HistoryRequest = function() {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  this.bb = null;

  /**
   * @type {number}
   */
  this.bb_pos = 0;
};

/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {chat.Schema.HistoryRequest}
 */
chat.Schema.HistoryRequest.prototype.__init = function(i, bb) {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.HistoryRequest=} obj
 * @returns {chat.Schema.HistoryRequest}
 */
chat.Schema.HistoryRequest.getRootAsHistoryRequest = function(bb, obj) {
  return (obj || new chat.Schema.HistoryRequest).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.HistoryRequest=} obj
 * @returns {chat.Schema.HistoryRequest}
 */
chat.Schema.HistoryRequest.getSizePrefixedRootAsHistoryRequest = function(bb, obj) {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new chat.Schema.HistoryRequest).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
chat.Schema.HistoryRequest.prototype.pagingStartTime = function(optionalEncoding) {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @returns {number}
 */
chat.Schema.HistoryRequest.prototype.pagingSize = function() {
  var offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
};

/**
 * @param {number} index
 * @returns {number}
 */
chat.Schema.HistoryRequest.prototype.roomId = function(index) {
  var offset = this.bb.__offset(this.bb_pos, 8);
  return offset ? this.bb.readInt32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};

/**
 * @returns {number}
 */
chat.Schema.HistoryRequest.prototype.roomIdLength = function() {
  var offset = this.bb.__offset(this.bb_pos, 8);
  return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @returns {Int32Array}
 */
chat.Schema.HistoryRequest.prototype.roomIdArray = function() {
  var offset = this.bb.__offset(this.bb_pos, 8);
  return offset ? new Int32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};

/**
 * @param {flatbuffers.Builder} builder
 */
chat.Schema.HistoryRequest.startHistoryRequest = function(builder) {
  builder.startObject(3);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} pagingStartTimeOffset
 */
chat.Schema.HistoryRequest.addPagingStartTime = function(builder, pagingStartTimeOffset) {
  builder.addFieldOffset(0, pagingStartTimeOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} pagingSize
 */
chat.Schema.HistoryRequest.addPagingSize = function(builder, pagingSize) {
  builder.addFieldInt32(1, pagingSize, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} roomIdOffset
 */
chat.Schema.HistoryRequest.addRoomId = function(builder, roomIdOffset) {
  builder.addFieldOffset(2, roomIdOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
chat.Schema.HistoryRequest.createRoomIdVector = function(builder, data) {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addInt32(data[i]);
  }
  return builder.endVector();
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
chat.Schema.HistoryRequest.startRoomIdVector = function(builder, numElems) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
chat.Schema.HistoryRequest.endHistoryRequest = function(builder) {
  var offset = builder.endObject();
  return offset;
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} pagingStartTimeOffset
 * @param {number} pagingSize
 * @param {flatbuffers.Offset} roomIdOffset
 * @returns {flatbuffers.Offset}
 */
chat.Schema.HistoryRequest.createHistoryRequest = function(builder, pagingStartTimeOffset, pagingSize, roomIdOffset) {
  chat.Schema.HistoryRequest.startHistoryRequest(builder);
  chat.Schema.HistoryRequest.addPagingStartTime(builder, pagingStartTimeOffset);
  chat.Schema.HistoryRequest.addPagingSize(builder, pagingSize);
  chat.Schema.HistoryRequest.addRoomId(builder, roomIdOffset);
  return chat.Schema.HistoryRequest.endHistoryRequest(builder);
}

/**
 * @constructor
 */
chat.Schema.Credentials = function() {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  this.bb = null;

  /**
   * @type {number}
   */
  this.bb_pos = 0;
};

/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {chat.Schema.Credentials}
 */
chat.Schema.Credentials.prototype.__init = function(i, bb) {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.Credentials=} obj
 * @returns {chat.Schema.Credentials}
 */
chat.Schema.Credentials.getRootAsCredentials = function(bb, obj) {
  return (obj || new chat.Schema.Credentials).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.Credentials=} obj
 * @returns {chat.Schema.Credentials}
 */
chat.Schema.Credentials.getSizePrefixedRootAsCredentials = function(bb, obj) {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new chat.Schema.Credentials).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
chat.Schema.Credentials.prototype.companyName = function(optionalEncoding) {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
chat.Schema.Credentials.prototype.userName = function(optionalEncoding) {
  var offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
chat.Schema.Credentials.prototype.password = function(optionalEncoding) {
  var offset = this.bb.__offset(this.bb_pos, 8);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @returns {number}
 */
chat.Schema.Credentials.prototype.type = function() {
  var offset = this.bb.__offset(this.bb_pos, 10);
  return offset ? this.bb.readInt16(this.bb_pos + offset) : 0;
};

/**
 * @returns {number}
 */
chat.Schema.Credentials.prototype.typeId = function() {
  var offset = this.bb.__offset(this.bb_pos, 12);
  return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
};

/**
 * @returns {boolean}
 */
chat.Schema.Credentials.prototype.signup = function() {
  var offset = this.bb.__offset(this.bb_pos, 14);
  return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
};

/**
 * @returns {boolean}
 */
chat.Schema.Credentials.prototype.autoSignup = function() {
  var offset = this.bb.__offset(this.bb_pos, 16);
  return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
};

/**
 * @param {flatbuffers.Builder} builder
 */
chat.Schema.Credentials.startCredentials = function(builder) {
  builder.startObject(7);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} companyNameOffset
 */
chat.Schema.Credentials.addCompanyName = function(builder, companyNameOffset) {
  builder.addFieldOffset(0, companyNameOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} userNameOffset
 */
chat.Schema.Credentials.addUserName = function(builder, userNameOffset) {
  builder.addFieldOffset(1, userNameOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} passwordOffset
 */
chat.Schema.Credentials.addPassword = function(builder, passwordOffset) {
  builder.addFieldOffset(2, passwordOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} type
 */
chat.Schema.Credentials.addType = function(builder, type) {
  builder.addFieldInt16(3, type, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} typeId
 */
chat.Schema.Credentials.addTypeId = function(builder, typeId) {
  builder.addFieldInt32(4, typeId, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {boolean} signup
 */
chat.Schema.Credentials.addSignup = function(builder, signup) {
  builder.addFieldInt8(5, +signup, +false);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {boolean} autoSignup
 */
chat.Schema.Credentials.addAutoSignup = function(builder, autoSignup) {
  builder.addFieldInt8(6, +autoSignup, +false);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
chat.Schema.Credentials.endCredentials = function(builder) {
  var offset = builder.endObject();
  builder.requiredField(offset, 6); // userName
  builder.requiredField(offset, 8); // password
  return offset;
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} companyNameOffset
 * @param {flatbuffers.Offset} userNameOffset
 * @param {flatbuffers.Offset} passwordOffset
 * @param {number} type
 * @param {number} typeId
 * @param {boolean} signup
 * @param {boolean} autoSignup
 * @returns {flatbuffers.Offset}
 */
chat.Schema.Credentials.createCredentials = function(builder, companyNameOffset, userNameOffset, passwordOffset, type, typeId, signup, autoSignup) {
  chat.Schema.Credentials.startCredentials(builder);
  chat.Schema.Credentials.addCompanyName(builder, companyNameOffset);
  chat.Schema.Credentials.addUserName(builder, userNameOffset);
  chat.Schema.Credentials.addPassword(builder, passwordOffset);
  chat.Schema.Credentials.addType(builder, type);
  chat.Schema.Credentials.addTypeId(builder, typeId);
  chat.Schema.Credentials.addSignup(builder, signup);
  chat.Schema.Credentials.addAutoSignup(builder, autoSignup);
  return chat.Schema.Credentials.endCredentials(builder);
}

/**
 * @constructor
 */
chat.Schema.Auth = function() {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  this.bb = null;

  /**
   * @type {number}
   */
  this.bb_pos = 0;
};

/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {chat.Schema.Auth}
 */
chat.Schema.Auth.prototype.__init = function(i, bb) {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.Auth=} obj
 * @returns {chat.Schema.Auth}
 */
chat.Schema.Auth.getRootAsAuth = function(bb, obj) {
  return (obj || new chat.Schema.Auth).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.Auth=} obj
 * @returns {chat.Schema.Auth}
 */
chat.Schema.Auth.getSizePrefixedRootAsAuth = function(bb, obj) {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new chat.Schema.Auth).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns {boolean}
 */
chat.Schema.Auth.prototype.verified = function() {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
};

/**
 * @returns {number}
 */
chat.Schema.Auth.prototype.userId = function() {
  var offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
};

/**
 * @param {flatbuffers.Builder} builder
 */
chat.Schema.Auth.startAuth = function(builder) {
  builder.startObject(2);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {boolean} verified
 */
chat.Schema.Auth.addVerified = function(builder, verified) {
  builder.addFieldInt8(0, +verified, +false);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} userId
 */
chat.Schema.Auth.addUserId = function(builder, userId) {
  builder.addFieldInt32(1, userId, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
chat.Schema.Auth.endAuth = function(builder) {
  var offset = builder.endObject();
  return offset;
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {boolean} verified
 * @param {number} userId
 * @returns {flatbuffers.Offset}
 */
chat.Schema.Auth.createAuth = function(builder, verified, userId) {
  chat.Schema.Auth.startAuth(builder);
  chat.Schema.Auth.addVerified(builder, verified);
  chat.Schema.Auth.addUserId(builder, userId);
  return chat.Schema.Auth.endAuth(builder);
}

/**
 * @constructor
 */
chat.Schema.Room = function() {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  this.bb = null;

  /**
   * @type {number}
   */
  this.bb_pos = 0;
};

/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {chat.Schema.Room}
 */
chat.Schema.Room.prototype.__init = function(i, bb) {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.Room=} obj
 * @returns {chat.Schema.Room}
 */
chat.Schema.Room.getRootAsRoom = function(bb, obj) {
  return (obj || new chat.Schema.Room).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.Room=} obj
 * @returns {chat.Schema.Room}
 */
chat.Schema.Room.getSizePrefixedRootAsRoom = function(bb, obj) {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new chat.Schema.Room).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns {number}
 */
chat.Schema.Room.prototype.roomID = function() {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
chat.Schema.Room.prototype.name = function(optionalEncoding) {
  var offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
chat.Schema.Room.prototype.lastMeReadTime = function(optionalEncoding) {
  var offset = this.bb.__offset(this.bb_pos, 8);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param {number} index
 * @param {chat.Schema.UserStatus=} obj
 * @returns {chat.Schema.UserStatus}
 */
chat.Schema.Room.prototype.userStatuses = function(index, obj) {
  var offset = this.bb.__offset(this.bb_pos, 10);
  return offset ? (obj || new chat.Schema.UserStatus).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
};

/**
 * @returns {number}
 */
chat.Schema.Room.prototype.userStatusesLength = function() {
  var offset = this.bb.__offset(this.bb_pos, 10);
  return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @param {flatbuffers.Builder} builder
 */
chat.Schema.Room.startRoom = function(builder) {
  builder.startObject(4);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} roomID
 */
chat.Schema.Room.addRoomID = function(builder, roomID) {
  builder.addFieldInt32(0, roomID, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} nameOffset
 */
chat.Schema.Room.addName = function(builder, nameOffset) {
  builder.addFieldOffset(1, nameOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} lastMeReadTimeOffset
 */
chat.Schema.Room.addLastMeReadTime = function(builder, lastMeReadTimeOffset) {
  builder.addFieldOffset(2, lastMeReadTimeOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} userStatusesOffset
 */
chat.Schema.Room.addUserStatuses = function(builder, userStatusesOffset) {
  builder.addFieldOffset(3, userStatusesOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<flatbuffers.Offset>} data
 * @returns {flatbuffers.Offset}
 */
chat.Schema.Room.createUserStatusesVector = function(builder, data) {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
chat.Schema.Room.startUserStatusesVector = function(builder, numElems) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
chat.Schema.Room.endRoom = function(builder) {
  var offset = builder.endObject();
  return offset;
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} roomID
 * @param {flatbuffers.Offset} nameOffset
 * @param {flatbuffers.Offset} lastMeReadTimeOffset
 * @param {flatbuffers.Offset} userStatusesOffset
 * @returns {flatbuffers.Offset}
 */
chat.Schema.Room.createRoom = function(builder, roomID, nameOffset, lastMeReadTimeOffset, userStatusesOffset) {
  chat.Schema.Room.startRoom(builder);
  chat.Schema.Room.addRoomID(builder, roomID);
  chat.Schema.Room.addName(builder, nameOffset);
  chat.Schema.Room.addLastMeReadTime(builder, lastMeReadTimeOffset);
  chat.Schema.Room.addUserStatuses(builder, userStatusesOffset);
  return chat.Schema.Room.endRoom(builder);
}

/**
 * @constructor
 */
chat.Schema.ListRoom = function() {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  this.bb = null;

  /**
   * @type {number}
   */
  this.bb_pos = 0;
};

/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {chat.Schema.ListRoom}
 */
chat.Schema.ListRoom.prototype.__init = function(i, bb) {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.ListRoom=} obj
 * @returns {chat.Schema.ListRoom}
 */
chat.Schema.ListRoom.getRootAsListRoom = function(bb, obj) {
  return (obj || new chat.Schema.ListRoom).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.ListRoom=} obj
 * @returns {chat.Schema.ListRoom}
 */
chat.Schema.ListRoom.getSizePrefixedRootAsListRoom = function(bb, obj) {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new chat.Schema.ListRoom).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {number} index
 * @param {chat.Schema.Room=} obj
 * @returns {chat.Schema.Room}
 */
chat.Schema.ListRoom.prototype.rooms = function(index, obj) {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? (obj || new chat.Schema.Room).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
};

/**
 * @returns {number}
 */
chat.Schema.ListRoom.prototype.roomsLength = function() {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @param {flatbuffers.Builder} builder
 */
chat.Schema.ListRoom.startListRoom = function(builder) {
  builder.startObject(1);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} roomsOffset
 */
chat.Schema.ListRoom.addRooms = function(builder, roomsOffset) {
  builder.addFieldOffset(0, roomsOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<flatbuffers.Offset>} data
 * @returns {flatbuffers.Offset}
 */
chat.Schema.ListRoom.createRoomsVector = function(builder, data) {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
chat.Schema.ListRoom.startRoomsVector = function(builder, numElems) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
chat.Schema.ListRoom.endListRoom = function(builder) {
  var offset = builder.endObject();
  return offset;
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} roomsOffset
 * @returns {flatbuffers.Offset}
 */
chat.Schema.ListRoom.createListRoom = function(builder, roomsOffset) {
  chat.Schema.ListRoom.startListRoom(builder);
  chat.Schema.ListRoom.addRooms(builder, roomsOffset);
  return chat.Schema.ListRoom.endListRoom(builder);
}

/**
 * @constructor
 */
chat.Schema.UserStatus = function() {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  this.bb = null;

  /**
   * @type {number}
   */
  this.bb_pos = 0;
};

/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {chat.Schema.UserStatus}
 */
chat.Schema.UserStatus.prototype.__init = function(i, bb) {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.UserStatus=} obj
 * @returns {chat.Schema.UserStatus}
 */
chat.Schema.UserStatus.getRootAsUserStatus = function(bb, obj) {
  return (obj || new chat.Schema.UserStatus).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.UserStatus=} obj
 * @returns {chat.Schema.UserStatus}
 */
chat.Schema.UserStatus.getSizePrefixedRootAsUserStatus = function(bb, obj) {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new chat.Schema.UserStatus).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns {number}
 */
chat.Schema.UserStatus.prototype.userId = function() {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
chat.Schema.UserStatus.prototype.userName = function(optionalEncoding) {
  var offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @returns {number}
 */
chat.Schema.UserStatus.prototype.status = function() {
  var offset = this.bb.__offset(this.bb_pos, 8);
  return offset ? this.bb.readInt8(this.bb_pos + offset) : 0;
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
chat.Schema.UserStatus.prototype.lastLogin = function(optionalEncoding) {
  var offset = this.bb.__offset(this.bb_pos, 10);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
chat.Schema.UserStatus.prototype.lastReadTime = function(optionalEncoding) {
  var offset = this.bb.__offset(this.bb_pos, 12);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param {flatbuffers.Builder} builder
 */
chat.Schema.UserStatus.startUserStatus = function(builder) {
  builder.startObject(5);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} userId
 */
chat.Schema.UserStatus.addUserId = function(builder, userId) {
  builder.addFieldInt32(0, userId, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} userNameOffset
 */
chat.Schema.UserStatus.addUserName = function(builder, userNameOffset) {
  builder.addFieldOffset(1, userNameOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} status
 */
chat.Schema.UserStatus.addStatus = function(builder, status) {
  builder.addFieldInt8(2, status, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} lastLoginOffset
 */
chat.Schema.UserStatus.addLastLogin = function(builder, lastLoginOffset) {
  builder.addFieldOffset(3, lastLoginOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} lastReadTimeOffset
 */
chat.Schema.UserStatus.addLastReadTime = function(builder, lastReadTimeOffset) {
  builder.addFieldOffset(4, lastReadTimeOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
chat.Schema.UserStatus.endUserStatus = function(builder) {
  var offset = builder.endObject();
  return offset;
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} userId
 * @param {flatbuffers.Offset} userNameOffset
 * @param {number} status
 * @param {flatbuffers.Offset} lastLoginOffset
 * @param {flatbuffers.Offset} lastReadTimeOffset
 * @returns {flatbuffers.Offset}
 */
chat.Schema.UserStatus.createUserStatus = function(builder, userId, userNameOffset, status, lastLoginOffset, lastReadTimeOffset) {
  chat.Schema.UserStatus.startUserStatus(builder);
  chat.Schema.UserStatus.addUserId(builder, userId);
  chat.Schema.UserStatus.addUserName(builder, userNameOffset);
  chat.Schema.UserStatus.addStatus(builder, status);
  chat.Schema.UserStatus.addLastLogin(builder, lastLoginOffset);
  chat.Schema.UserStatus.addLastReadTime(builder, lastReadTimeOffset);
  return chat.Schema.UserStatus.endUserStatus(builder);
}

/**
 * @constructor
 */
chat.Schema.AppStatus = function() {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  this.bb = null;

  /**
   * @type {number}
   */
  this.bb_pos = 0;
};

/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {chat.Schema.AppStatus}
 */
chat.Schema.AppStatus.prototype.__init = function(i, bb) {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.AppStatus=} obj
 * @returns {chat.Schema.AppStatus}
 */
chat.Schema.AppStatus.getRootAsAppStatus = function(bb, obj) {
  return (obj || new chat.Schema.AppStatus).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.AppStatus=} obj
 * @returns {chat.Schema.AppStatus}
 */
chat.Schema.AppStatus.getSizePrefixedRootAsAppStatus = function(bb, obj) {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new chat.Schema.AppStatus).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns {number}
 */
chat.Schema.AppStatus.prototype.status = function() {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? this.bb.readInt8(this.bb_pos + offset) : 0;
};

/**
 * @param {flatbuffers.Builder} builder
 */
chat.Schema.AppStatus.startAppStatus = function(builder) {
  builder.startObject(1);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} status
 */
chat.Schema.AppStatus.addStatus = function(builder, status) {
  builder.addFieldInt8(0, status, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
chat.Schema.AppStatus.endAppStatus = function(builder) {
  var offset = builder.endObject();
  return offset;
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} status
 * @returns {flatbuffers.Offset}
 */
chat.Schema.AppStatus.createAppStatus = function(builder, status) {
  chat.Schema.AppStatus.startAppStatus(builder);
  chat.Schema.AppStatus.addStatus(builder, status);
  return chat.Schema.AppStatus.endAppStatus(builder);
}

/**
 * @constructor
 */
chat.Schema.AppNotification = function() {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  this.bb = null;

  /**
   * @type {number}
   */
  this.bb_pos = 0;
};

/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {chat.Schema.AppNotification}
 */
chat.Schema.AppNotification.prototype.__init = function(i, bb) {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.AppNotification=} obj
 * @returns {chat.Schema.AppNotification}
 */
chat.Schema.AppNotification.getRootAsAppNotification = function(bb, obj) {
  return (obj || new chat.Schema.AppNotification).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {chat.Schema.AppNotification=} obj
 * @returns {chat.Schema.AppNotification}
 */
chat.Schema.AppNotification.getSizePrefixedRootAsAppNotification = function(bb, obj) {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new chat.Schema.AppNotification).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns {number}
 */
chat.Schema.AppNotification.prototype.phoneType = function() {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? this.bb.readInt8(this.bb_pos + offset) : 0;
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
chat.Schema.AppNotification.prototype.deviceId = function(optionalEncoding) {
  var offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
chat.Schema.AppNotification.prototype.token = function(optionalEncoding) {
  var offset = this.bb.__offset(this.bb_pos, 8);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param {flatbuffers.Builder} builder
 */
chat.Schema.AppNotification.startAppNotification = function(builder) {
  builder.startObject(3);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} phoneType
 */
chat.Schema.AppNotification.addPhoneType = function(builder, phoneType) {
  builder.addFieldInt8(0, phoneType, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} deviceIdOffset
 */
chat.Schema.AppNotification.addDeviceId = function(builder, deviceIdOffset) {
  builder.addFieldOffset(1, deviceIdOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} tokenOffset
 */
chat.Schema.AppNotification.addToken = function(builder, tokenOffset) {
  builder.addFieldOffset(2, tokenOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
chat.Schema.AppNotification.endAppNotification = function(builder) {
  var offset = builder.endObject();
  return offset;
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} phoneType
 * @param {flatbuffers.Offset} deviceIdOffset
 * @param {flatbuffers.Offset} tokenOffset
 * @returns {flatbuffers.Offset}
 */
chat.Schema.AppNotification.createAppNotification = function(builder, phoneType, deviceIdOffset, tokenOffset) {
  chat.Schema.AppNotification.startAppNotification(builder);
  chat.Schema.AppNotification.addPhoneType(builder, phoneType);
  chat.Schema.AppNotification.addDeviceId(builder, deviceIdOffset);
  chat.Schema.AppNotification.addToken(builder, tokenOffset);
  return chat.Schema.AppNotification.endAppNotification(builder);
}

// Exports for Node.js and RequireJS
this.chat = chat;
